import { AppBar, Button, Card, CardContent, FormControlLabel, Grid, Switch, Toolbar, Tooltip, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import LoadingIndicator from '../../components/general/loadingIndicator/LoadingIndicator';
import { MySnackbar } from '../../components/general/mySnackbar/MySnackbar';
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import serviceRest from '../../services/serviceRest'
import Input from '../../components/general/form/Input';
import CheckboxC from '../../components/general/form/Checkbox';
import VideocamIcon from '@material-ui/icons/Videocam';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import PanoramaIcon from '@material-ui/icons/Panorama';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import Radio from '../../components/general/form/Radio';
import clsx from 'clsx';
import AuthorsSelection from './AuthorsSelection';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    grow: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginLeft: theme.spacing(0),
    },
    title: {
        fontSize: 20,
    },
    formTitle: {
        fontWeight: "bold",
    },
    infoSalleIcon: {
        // paddingTop: "20px",
        marginLeft: "10px",
    }
}));


const MediaServerForm = ({ handleApplyColSettings, setOpenColSettings }) => {
    let { mediaserverId } = useParams();

    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [snack, setSnack] = useState({});

    // formulaire
    const { control, handleSubmit, reset, setValue, watch } = useForm({
        defaultValues: {
            ID: 0,
            recordOn: true,
            emailOwner: 0,
            title: "",
            easyDownload: true,
            autoPublication: true,
            authors: [],
            recordDates: [],
            recordDatesV2:[],
            accessPermission: "",
            visibilityLimit: "",
            mediatype: "",
            extraRecordTime: "",
            visibilityLimitDate: null,
            live: false,
            publicLive: false,
            layoutType: "",
            encoderType: "",
            user: "",
            psw: "",
            pswRepeat: "",
            homeOrganization: [],
        }
    });
    const [watchLive, watchMediaType, watchExtraRecordTime] = watch(["live", "mediatype", "extraRecordTime"]);

    const onSubmit = data => {
        console.log(data)
        data.authors = authorsList;
        data.authors = data.authors.filter((item) => (item.firstname !== "" && item.lastname !== ""))
        if (data.authors.length>0) {
            setAuthorsList(data.authors)
            let homeOrganizationFormatedList = [];
            for (let index = 0; index < data.homeOrganization.length; index++) {
                const element = data.homeOrganization[index];
                let organizationObject = homeOrganizationList.filter(item => item.label === element)
                homeOrganizationFormatedList.push(organizationObject[0])
            }
            data.homeOrganization = homeOrganizationFormatedList;

            if (mediaserverId) {
                if (typeof data.emailOwner !== "string") {
                    let result = ownerEmailList.filter(item => item.value === data.emailOwner)
                    if (result.length === 1)
                        data.emailOwner = JSON.stringify(result[0])
                } else {
                    data.emailOwner = JSON.stringify({ label: data.emailOwner, value: data.emailOwner })
                }

                // setLoading(true)
                serviceRest.post('/mediaserver/reservation/save', { row: JSON.stringify(data) }).then((response) => {
                    if (response.data.error) {
                        // setLoading(false)
                        setSnack({ message: response.data.message, show: true, severity: "error" })
                    } else {
                        setSnack({ message: response.data.message, show: true, severity: "success" })
                    }
                }, (error) => {
                    // setLoading(false)
                    setSnack({ message: "Une erreur est survenue : " + JSON.stringify(error), show: true, severity: "error" })
                });
            } else {
                handleApplyColSettings(data)
            }
        } else {
            setSnack({ message: "Veulllez renseigner au minimum un auteur.", show: true, severity: "error" })
        }
    }

    //enum
    const [ownerEmailList, setOwnerEmailList] = useState([]);
    const [accessList, setAccessList] = useState([]);
    const [layoutList, setLayoutList] = useState([]);
    const [homeOrganizationList, setHomeOrganizationList] = useState([]);
    const [qualitiesList, setQualitiesList] = useState([]);


    const [recordDatesList, setRecordDatesList] = useState([]);
    const [technician, setTechnician] = useState(false);
    //infoSalles
    const [infosSalle, setInfosSalle] = useState({ live: true, has_camera: true, editable:true });
    const [customOwner, setCustomOwner] = useState(false);
    const [disableAccessPermission, setDisableAccessPermission] = useState(false);
    const [authorsList, setAuthorsList] = useState([]);
    const [extraRecordTimeList, setExtraRecordTimeList] = useState([]);

    const visibilityType = [
        { value: 0, label: "Illimité" },
        { value: 1, label: "1 an" },
        { value: 2, label: "5 ans" },
        { value: 3, label: "Je souhaite préciser une date" },
    ]

    const mediaTypeList = [
        { value: "0", label: "Audio uniquement" },
        { value: "1", label: "Vidéo" },
    ]

    // const extraRecordTimeList = [
    //     { value: "0", label: "0" },
    //     { value: "5", label: "+5" },
    //     { value: "10", label: "+10" },
    //     { value: "15", label: "+15" },
    // ]

    useEffect(() => {

        serviceRest.get('/mediaserver/enum/accessPermission').then((response) => {
            if (response.data.error) {
                setLoading(false)
                setSnack({ message: response.data.message, show: true, severity: "error" })
            } else {
                setAccessList(response.data.accessList)
            }
        }, (error) => {
            setLoading(false)
            setSnack({ message: "Une erreur est survenue : " + JSON.stringify(error), show: true, severity: "error" })
        });

        let url = '/mediaserver/enum/getLayout'
        if (technician) {
            url += '?fromMediaserver=true'
        }
        serviceRest.get(url).then((response) => {
            if (response.data.error) {
                setLoading(false)
                setSnack({ message: response.data.message, show: true, severity: "error" })
            } else {
                setLayoutList(response.data.layoutList)
            }
        }, (error) => {
            setLoading(false)
            setSnack({ message: "Une erreur est survenue : " + JSON.stringify(error), show: true, severity: "error" })
        });

        serviceRest.get('/mediaserver/enum/getHomeOrganization').then((response) => {
            if (response.data.error) {
                setLoading(false)
                setSnack({ message: response.data.message, show: true, severity: "error" })
            } else {
                setHomeOrganizationList(response.data.homeOrganizationList)
            }
        }, (error) => {
            setLoading(false)
            setSnack({ message: "Une erreur est survenue : " + JSON.stringify(error), show: true, severity: "error" })
        });

        if (technician) {
            serviceRest.get('/mediaserver/enum/getQualities').then((response) => {
                if (response.data.error) {
                    setLoading(false)
                    setSnack({ message: response.data.message, show: true, severity: "error" })
                } else {
                    setQualitiesList(response.data.qualitiesList)
                }
            }, (error) => {
                setLoading(false)
                setSnack({ message: "Une erreur est survenue : " + JSON.stringify(error), show: true, severity: "error" })
            });
        }

        if (mediaserverId) {
            let params = { "mediaserverId": mediaserverId };
            serviceRest.post('/mediaserver/enum/getPossibleOwner', params).then((response) => {
                if (response.data.error) {
                    setLoading(false)
                    setSnack({ message: response.data.message, show: true, severity: "error" })
                } else {
                    setOwnerEmailList(response.data.ownerList)
                }
            }, (error) => {
                setLoading(false)
                setSnack({ message: "Une erreur est survenue : " + JSON.stringify(error), show: true, severity: "error" })
            });
        }



    }, [mediaserverId, technician]);

    useEffect(() => {
        //données de base ok
        if ((accessList.length > 0) && (layoutList.length > 0)) {

            if (mediaserverId) {
                let params = { "mediaserverId": mediaserverId }
                serviceRest.post('/mediaserver/reservation/getForm', params).then((response) => {
                    if (response.data.error) {
                        setLoading(false)
                        setSnack({ message: response.data.message, show: true, severity: "error" })
                    } else {
                        for (let index = 0; index < response.data.infos.authors.length; index++) {
                            const element = response.data.infos.authors[index];
                            element.id = uuidv4()
                        }
                        setExtraRecordTimeList(response.data.infosSalle.allInfos.extraRecordTimeList)
                        setAuthorsList(response.data.infos.authors)
                        setCustomOwner((typeof response.data.infos.emailOwner === "string"))
                        // setRecordDatesList(response.data.infos.recordDates)
                         setRecordDatesList(response.data.infos.recordDatesV2)
                        setInfosSalle(response.data.infosSalle.allInfos)
                        setTechnician(response.data.isTechnician)
                        reset(response.data.infos)
                        setLoading(false)
                    }
                }, (error) => {
                    setLoading(false)
                    setSnack({ message: "Une erreur est survenue : " + error.message, show: true, severity: "error" })
                });
            } else {
                reset(
                    {
                        ID: 0,
                        recordOn: true,
                        emailOwner: 0,
                        title: "",
                        easyDownload: false,
                        autoPublication: false,
                        authors: [],
                        recordDates: [],
                        recordDatesV2:[],
                        accessPermission: "",
                        visibilityLimit: "",
                        mediatype: "",
                        extraRecordTime:"",
                        visibilityLimitDate: null,
                        live: false,
                        publicLive: false,
                        layoutType: "",
                        encoderType: "",
                        user: "",
                        psw: "",
                        pswRepeat: "",
                        homeOrganization: [],
                    }
                )
                setLoading(false)
            }

        }

    }, [accessList, layoutList, mediaserverId, reset]);

    useEffect(() => {

        if (customOwner) {
            setValue("emailOwner", "")
        }

    }, [customOwner, setValue]);

    useEffect(() => {

        if (watchLive) {
            setDisableAccessPermission(true)
            setValue("autoPublication", true)
        } else {
            setDisableAccessPermission(false)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchLive]);

    function manageEndTime(endTime) {
        return moment(endTime, 'HH:mm').add(parseInt(watchExtraRecordTime), 'minutes').format('HH:mm')
    }

    return (
        <>
            {mediaserverId &&
                <AppBar
                    position="fixed"
                    className={classes.appBar}
                >
                    <Toolbar>
                        <Typography variant="h6" noWrap>
                            Mobilys
                        </Typography>
                        <div className={classes.grow} />
                    </Toolbar>
                </AppBar>}
            <main className={clsx({
                [classes.content]: mediaserverId,
            })}>
                <div className={clsx({
                    [classes.toolbar]: mediaserverId,
                })} />
                <LoadingIndicator open={loading} />
                <MySnackbar params={snack} />
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                {mediaserverId &&
                                    <Grid container alignItems="flex-start" justifyContent="space-between" spacing={0}>
                                        <Grid item>
                                            <Typography className={classes.title} color="textPrimary">
                                                Demande d'enregistrement Mediaserver
                                            </Typography>
                                        </Grid>
                                        {/* infos salle équipements icon */}
                                        {mediaserverId &&
                                            <Grid item>
                                                {!infosSalle ?
                                                    <Tooltip
                                                        title={<h3>Aucun équipement, enregistrement impossible.</h3>}
                                                        aria-label="Aucun équipement, enregistrement impossible."
                                                        placement="bottom"
                                                    >
                                                        <NotInterestedIcon style={{ color: "red" }} fontSize="large" className={classes.infoSalleIcon} color="primary" />
                                                    </Tooltip>
                                                    : <>
                                                        {infosSalle.has_camera ?
                                                            <Tooltip
                                                                title={<h3>Capture audio + document projeté + caméra</h3>}
                                                                aria-label="Capture audio + document projeté + caméra"
                                                                placement="bottom"
                                                            >
                                                                <VideocamIcon className={classes.infoSalleIcon} color="primary" />
                                                            </Tooltip>
                                                            :
                                                            <Tooltip
                                                                title={<h3>Capture audio + document projeté</h3>}
                                                                aria-label="Capture audio + document projeté"
                                                                placement="bottom"
                                                            >
                                                                <PanoramaIcon className={classes.infoSalleIcon} color="primary" />
                                                            </Tooltip>}

                                                        {infosSalle.live &&
                                                            <Tooltip
                                                                title={<h3>Diffusion live</h3>}
                                                                aria-label="Diffusion live"
                                                                placement="bottom"
                                                            >
                                                                <SettingsInputAntennaIcon className={classes.infoSalleIcon} color="primary" />
                                                            </Tooltip>
                                                        }
                                                    </>
                                                }
                                            </Grid>}
                                        <Grid item>
                                            <Typography className={classes.title} color="textPrimary">
                                                {infosSalle.libelle &&
                                                    <span style={{ float: "right" }}>{infosSalle.libelle + " / " + infosSalle.startTime + "-" + manageEndTime(infosSalle.endTime) + (infosSalle.days!=="" ? " / " + infosSalle.days:"")}</span>
                                                }
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <hr />
                                        </Grid>
                                        {infosSalle.libelle ? (!infosSalle.editable &&
                                            <Grid item xs={12}>
                                                <Typography color="error">{!infosSalle.editableDates ? "Modification impossible, toutes les dates de la réservation sont passées." : "Vous pouvez uniquement retirer et ajouter des dates futures sur cette demande."}</Typography>
                                            </Grid>) : null}
                                    </Grid>
                                }
                                {!loading &&
                                    <form>
                                        <Grid container alignItems="flex-start" spacing={2}>
                                            <CheckboxC
                                                controllerProps={{ control, name: 'recordOn' }}
                                                label={"Autoriser l'enregistrement Mediaserver"}
                                                gridProps={{ md: 6 }}
                                                disabled={!infosSalle.editable}
                                            />
                                            <Radio
                                                controllerProps={{
                                                    control,
                                                    name: 'extraRecordTime',
                                                    defaultValue: "",
                                                    row: true,
                                                }}
                                                disabled={!infosSalle.editable}
                                                label={"Rallonger la durée (minutes)"}
                                                gridProps={{ md: 6 }}
                                                selectOptions={extraRecordTimeList}
                                            />
                                            {mediaserverId &&
                                                <>
                                                    <Grid item xs={12} md={12}>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={customOwner}
                                                                    onChange={(event, newValue) => {
                                                                        setCustomOwner(newValue);
                                                                    }}
                                                                color="primary"
                                                                disabled={!infosSalle.editable}
                                                                />
                                                            }
                                                            label="Propriétaire personnalisé"
                                                        />
                                                    </Grid>
                                                    {customOwner ?
                                                        <Input
                                                            controllerProps={{
                                                                control,
                                                            name: 'emailOwner',
                                                                rules: {
                                                                    required: true,
                                                                    errorMsg: "Champ requis",
                                                                    pattern: {
                                                                        value: /\S+@\S+\.\S+/,
                                                                        message: "Format email invalide."
                                                                    }
                                                                }
                                                        }}
                                                        disabled={!infosSalle.editable}
                                                            label={"Email de propriétaire"}
                                                        />
                                                        :
                                                        <Input
                                                        controllerProps={{
                                                                control,
                                                                name: 'emailOwner',
                                                                rules: { required: true, errorMsg: "Champ requis" }
                                                        }}
                                                        disabled={!infosSalle.editable}
                                                            label={"Email de propriétaire"}
                                                            select
                                                            selectOptions={ownerEmailList}
                                                        />}
                                                </>}
                                            <CheckboxC
                                                controllerProps={{ control, name: 'easyDownload' }}
                                                label={"Autoriser téléchargement facilité"}
                                                disabled={!infosSalle.editable}
                                            />
                                            {mediaserverId &&
                                                <Input
                                                    controllerProps={{ control, name: 'title', rules: { required: true, errorMsg: "Champ requis" } }}
                                                label={"Titre"}
                                                disabled={!infosSalle.editable}
                                                />}
                                            <CheckboxC
                                                controllerProps={{ control, name: 'autoPublication' }}
                                                label={"Activer publication automatique"}
                                                disabled={disableAccessPermission || !infosSalle.editable}
                                            />
                                            {mediaserverId &&
                                                <>
                                                <AuthorsSelection authorsList={authorsList} setAuthorsList={setAuthorsList} disabled={!infosSalle.editable} />
                                                    <Input
                                                        controllerProps={{
                                                            control,
                                                            name: 'recordDates',
                                                            multipleSelect: true,
                                                    }}
                                                    disabled={!infosSalle.editableDates}
                                                        label={"Dates d'enregistrement"}
                                                        select
                                                        selectOptions={recordDatesList}
                                                    />
                                                </>
                                            }
                                            <Input
                                                controllerProps={{
                                                    control,
                                                    name: 'accessPermission',
                                                    defaultValue: 1,
                                                    helper: true,
                                                    rules: { required: true, errorMsg: "Champ requis" },
                                                    conditionalField: [[
                                                        <Input
                                                            key={1}
                                                            controllerProps={{ control, name: 'user', rules: { required: true, errorMsg: "Champ requis" } }}
                                                            label={"utilisateur"}
                                                            disabled={!infosSalle.editable}
                                                        />,
                                                        <Input
                                                            key={2}
                                                            controllerProps={{ control, name: 'psw', rules: { required: true, errorMsg: "Champ requis" } }}
                                                            label={"mot de passe"}
                                                            type="password"
                                                            disabled={!infosSalle.editable}
                                                        />,
                                                        <Input
                                                            key={3}
                                                            controllerProps={{ control, name: 'pswRepeat', rules: { required: true, errorMsg: "Champ requis" } }}
                                                            label={"mot de passe  (répéter)"}
                                                            type="password"
                                                            disabled={!infosSalle.editable}
                                                        />
                                                    ],
                                                    <Input
                                                        controllerProps={{
                                                            control,
                                                            name: 'homeOrganization',
                                                            multipleSelect: true,
                                                            defaultValue: 0,
                                                            rules: { required: true, errorMsg: "Champ requis" },
                                                        }}
                                                        label={"Organisations"}
                                                        select
                                                        disabled={!infosSalle.editable}
                                                        selectOptions={homeOrganizationList.map(orga => orga.label)} />
                                                    ],
                                                    conditionalFieldCondition: [5, 6],
                                                }}
                                                label={"Permission d'accès"}
                                                select
                                                disabled={!infosSalle.editable}
                                                selectOptions={accessList}
                                            />
                                            <Input
                                                controllerProps={{
                                                    control,
                                                    name: 'visibilityLimit',
                                                    defaultValue: "",
                                                    rules: { required: true, errorMsg: "Champ requis" },
                                                    conditionalField: [<Input
                                                        controllerProps={{ control, name: 'visibilityLimitDate', rules: { required: true, errorMsg: "Champ requis" } }}
                                                        // label={"Date fin publication"}
                                                        type="date"
                                                    />],
                                                    conditionalFieldCondition: [3],
                                                }}
                                                disabled={!infosSalle.editable}
                                                label={"Limite de visibilité"}
                                                select
                                                selectOptions={visibilityType}
                                            />
                                            <Radio
                                                controllerProps={{
                                                    control,
                                                    name: 'mediatype',
                                                    defaultValue: "",
                                                    conditionalField: infosSalle.has_camera ? [<Radio
                                                        controllerProps={{
                                                            control,
                                                            name: 'layoutType',
                                                            defaultValue: "",
                                                            // helper: true,
                                                            rules: { required: true, errorMsg: "Champ requis", min: "1" }
                                                        }}
                                                        disabled={!infosSalle.editable}
                                                        label={"Disposition d'affichage (Layout)"}
                                                        selectOptions={layoutList}
                                                        gridProps={{ md: 12 }}
                                                    />] : [null],
                                                    conditionalFieldCondition: ["1"],
                                                    rules: { required: true, errorMsg: "Champ requis" }
                                                }}
                                                disabled={!infosSalle.editable}
                                                label={"Type de média à enregistrer"}
                                                selectOptions={mediaTypeList}
                                            />
                                            {(technician && watchMediaType === "1") &&
                                                <Radio
                                                    controllerProps={{
                                                        control,
                                                        name: 'encoderType',
                                                        defaultValue: "",
                                                        // helper: true,
                                                        rules: { required: true, errorMsg: "Champ requis", min: "1" }
                                                }}
                                                disabled={!infosSalle.editable}
                                                    label={"Qualité d'encodage"}
                                                    selectOptions={qualitiesList}
                                                    gridProps={{ md: 12 }}
                                                />
                                            }
                                            {infosSalle.live && <>
                                                <CheckboxC
                                                    controllerProps={{ control, name: 'live', helper: disableAccessPermission ? "L'accès au Live sera donné à l'ensemble des membres de la communauté Unige, ceci quel que soit votre choix de permissions d'accès pour les enregistrements.<br> De plus, la publication a été activé et est obligatoire." : null, }}
                                                    label={"Diffusion live"}
                                                    gridProps={{ md: 12 }}
                                                    disabled={!infosSalle.editable}
                                                />
                                                {technician &&
                                                <CheckboxC
                                                    controllerProps={{ control, name: 'publicLive' }}
                                                    label={"Live publique"}
                                                    gridProps={{ md: 12 }}
                                                    disabled={!infosSalle.editable}
                                                />}
                                            </>
                                            
                                            }
                                        </Grid>
                                        <Grid container alignItems="center" justifyContent="flex-end" spacing={2}>
                                            <Grid item>
                                                {/* <input type="submit" /> */}
                                                <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)} disabled={!infosSalle.editable && !infosSalle.editableDates}>
                                                    {mediaserverId ? "Valider" : "Appliquer"}
                                                </Button>
                                                {!mediaserverId &&
                                                    <Button style={{ marginLeft: "5px" }} variant="contained" color="secondary" onClick={_ => setOpenColSettings(false)}>
                                                        Annuler
                                                    </Button>}
                                            </Grid>
                                        </Grid>
                                    </form>}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </main>
        </>
    )
}

export default MediaServerForm